import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { environment } from './../../../../../environment/environment';
import { serverError } from './../../../../core/models/messages';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EsnAppeloffreService } from './../../../../core/services/esn-appeloffre/esn-appeloffre.service';
import { EsnJobOfferService } from './../../../../core/services/esn-job-offer-service/esn-job-offer.service';
import { SalarieService } from './../../../../core/services/salarie-service/salarie.service';
import { SortDataService } from './../../../../core/services/sortdata';
import { Country, IState, State } from 'country-state-city';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { translations } from '../../../../core/models/call-offer';
import { PageEvent } from '@angular/material/paginator';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-offre-entreprises',
  templateUrl: './offre-entreprises.component.html',
  styleUrls: ['./offre-entreprises.component.css'],
})
export class OffreEntreprisesComponent {
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  freeSearch: boolean = false;
  freeSearchActive :boolean = false;
  activeForm: 'freeSearch' | 'guidedSearch' | null = null;
  btnSearchactive : boolean = false;
  pageSize = 5;
  pageSizeOptions = [5, 10, 20];
  @ViewChild('editor') editor: any; // ViewChild reference to the Quill editor
  loadSpinner: boolean = false;
  itemsPerPage: number = 5;
  currentPage: number = 0;
  currentSortDirection: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  totalItems!: number;
  skills: any = [];
  name: any = [];
  pagination : boolean =false;

  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  countries: any = [];
  stateList!: IState[];
  backGroundColors: string[] = [
    'blue',
    'orange',
    'bleu-clair',
    'pink',
    'rose',
    'jaune',
    'rouge',
  ];
  sortAttr = '';
  listjoboffers: any;
  urlimage: string = environment.baseUrlGalery;
  urlcv: string = environment.baseUrlGaleryCv;
  url: string = environment.baseUrl + '/api';
  loadSpinnerTable: boolean = false;
  searchForm: FormGroup = this.createSearchForm();
  updateform!: FormGroup;
  skillsList: { name_FR: string }[] = [];
  dataHeader: any = [];
  listNames: string[] = [];
  currentSortColumn: string = 'name'; // Initial column to sort by
  private unsubscribeAll: Subject<void> = new Subject();
 freeSearchForm: FormGroup = this.createFreeSearchForm();
  seeMore: boolean = false;
  types: any = [];
  profile = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  passeport = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  state = [
    { id: 0, name: 'Actif' },
    { id: 1, name: 'Non Actif' },
  ];
  isCollapsed = true;
  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
  compt = [
    { id: 1, name: 'Immédiate' },
    { id: 2, name: '1 mois' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];
  contrat = [
    { id: 1, name: 'Alternance' },
    { id: 2, name: 'Autres type de contrat' },
    { id: 3, name: 'CDD' },
    { id: 4, name: 'CDI' },
    { id: 5, name: 'Freelance' },
    { id: 6, name: 'Portage salarial' },
    { id: 7, name: 'Stage' },
  ];
  disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];

  postType = [
    { id: '1', name: 'A distance' },
    { id: '2', name: 'Hybride' },
    { id: '3', name: 'Sur site' },
  ];
  contratType = [
    { id: '1', name: 'Alternance' },
    { id: '2', name: 'Autres type de contrat' },
    { id: '3', name: 'CDD' },
    { id: '4', name: 'CDI' },
    { id: '5', name: 'Freelance' },
    { id: '6', name: 'Portage salarial' },
    { id: '7', name: 'Stage' },
  ];

  poste = [
    { id: 1, name: 'A distance' },
    { id: 2, name: 'Hybride' },
    { id: 3, name: 'Sur site' },
  ];
  id = this.activatedRoute.snapshot.params['id'];

  startSearching:boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private jobofferservice: EsnJobOfferService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private sortDataService: SortDataService,
    private salarieservice: SalarieService,
    private appeloffreservice: EsnAppeloffreService,
    private activatedRoute: ActivatedRoute,
    private localStorageService: LocalStorageService,
    private elRef: ElementRef,
     private datePipe: DatePipe,
  ) {}

  ngOnInit() {
    this.getListSkills();
    this.getListjoboffer();
    this.getListElementHeader();
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
    this.countries = Country.getAllCountries();
    this.updateform = this.formBuilder.group({
      id: ['', Validators.required],
      name: ['', Validators.required],
      city: ['', Validators.required],
      country: ['', Validators.required],
      post_type: ['', Validators.required],
      contract_type: ['', Validators.required],
      availability: ['', Validators.required],
      skills: ['', Validators.required],
      years_of_experience: ['', Validators.required],
      tjm: ['', Validators.required],
      salary: ['', Validators.required],
      description: ['', Validators.required],
    });
  }
  setActiveForm(form: 'freeSearch' | 'guidedSearch') {
      this.activeForm = form;
      if (form === 'freeSearch') {
        this.freeSearchActive = true;
        this.freeSearchForm.enable();
      } else if (form === 'guidedSearch') {
        this.freeSearchActive = false;
        this.searchForm.enable(); 
      }
  }
    createFreeSearchForm(){
    return this.formBuilder.group({
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
    });
  }
  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');
    
    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
    }
  }
  ngAfterViewInit() {}

  // sortData(item: string) {
  //   this.sortAttr = item;
  //   this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
  //   this.currentPage = 1;
  //   this.endIndex = 5;
  //   if (this.searchForm.value != '')
  //     this.listjoboffers = this.sortDataService.sortArray(
  //       this.listjoboffers,
  //       this.sortAttr,
  //       this.currentSortDirection
  //     );
  //   else this.getListjoboffer();
  // }
  displayFreeSearch() {
    this.freeSearch = !this.freeSearch;
    this.currentPage = 0;
    if(this.freeSearch) {
       this.searchForm = this.createSearchForm();
       this.searchForm.reset();
       this.getListjoboffer();
      // 
      //  this.getListoffrebesoinesn();
    }
    else {
      this.freeSearchForm.reset();
      this.freeSearchForm = this.createFreeSearchForm();
      this.getListjoboffer();
      // this.getListoffrebesoinesn();
    }
  }
   onSubmit() {
    if(!this.freeSearchActive) {
      this.btnSearchactive = true;
      this.currentPage=0;
      this.searchjoboffer(this.currentPage);
    } else{
      this.btnSearchactive = true;
      this.currentPage=0;
      this.freeSearchjoboffer(this.currentPage);
    }
  }
  getListElementHeader() {
    this.appeloffreservice
      .getHeaderElements(16)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.dataHeader = res.data;
          for (const iterator of this.dataHeader) {
            if (
              (iterator.checked == 'oui' && !iterator.checked_user) ||
              (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
              (iterator.checked == 'oui' && iterator.checked_user == 'oui')
            )
              this.listNames.push(iterator.name);
          }
          this.dataHeader.map((el: any) => {
            if (
              (el.checked == 'oui' && !el.checked_user) ||
              (el.checked_user == 'oui' &&
                (el.checked == 'non' || el.checked == 'oui'))
            ) {
              return (el.checkAdmin = true);
            } else {
              return (el.checkAdmin = false);
            }
          });
        },
        error: () => {},
      });
  }

  changeSelection(event: any, data: any, i: number) {
    this.listNames = [];
    data.checkAdmin = event.target.checked;
    for (const iterator of this.dataHeader) {
      if (iterator.checkAdmin) this.listNames.push(iterator.name);
    }
    this.changeSelectionHeadrElements(data);
  }
  changeSelectionHeadrElements(data: any) {
    let payload = {
      sub_page_id: data?.id,
    };
  }
  translateCountryName(name: string): string {
    
    return translations[name] || name;
  }
  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
      if (this.searchForm.dirty) {
        this.searchjoboffer();
      } else if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){        this.pagination = true
        this.getListjoboffer();
      }
    }
  }

  onCountryChange(event: any): void {
    if (event) {
      this.stateList = State.getStatesOfCountry(event.isoCode);
      for (const iterator of this.stateList) {
        iterator.name = iterator.name.replace(' Governorate', '');
      }
    } else {
      this.stateList = [];
      this.searchForm.get('city')?.setValue(null);
    }
  }

  getListjoboffer() {
    let dataPyload = {
          esn_id: this.id,
          per_page: this.pageSize,
          page: this.currentPage,
        }
       
    this.jobofferservice.getListjobofferByESN(dataPyload).subscribe({
      next: (response: any) => {
        if (response.data && response.data.data) {
          this.listjoboffers = response.data.data
          // .slice(0, this.endIndex);
          this.totalItems = response.data.total;
          this.spinner.hide();
          this.loadSpinnerTable = false;
        }
      },
      error: (error: any) => {
      },
    });
  }
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      ID_jobOffer: ['', data?.ID_jobOffer],
      esn_id: ['', data?.esn_id],
      name: ['', data?.name],
      years_of_experience: ['', data?.years_of_experience],
      experience_range: ['', data?.experience_range],
      contract_type: [[], data?.contract_type],
      skillsOr: [[], data?.skillsOr],
      skillsAnd: [[], data?.skillsAnd],
      availability: [[], data?.availability],
      start_date: ['', data?.start_date],
      end_date: ['', data?.end_date],
      post_type: [[], data?.post_type],
      city: [[], data?.city],
      country: [null, data?.country],
      profile_abroad: [null, data?.profile_abroad],
      passeport_talent: [null, data?.passeport_talent],
      state: [null, data?.state],
      tjm: ['', data?.tjm],
      tjm_range: ['', data?.tjm_range],
      desired_salary: ['', data?.desired_salary],
      desired_salary_range: ['', data?.desired_salary_range],
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
    });
  }
  /* search */
  searchjoboffer(pageNumber : number = this.currentPage) {
    let valueForm = this.searchForm.value;
    valueForm.desired_salary_range = this.convertKToNumber(valueForm.desired_salary_range?.toString());
    let formattedEndDate = this.datePipe.transform(valueForm.end_date, 'yyyy-MM-dd');
    let formattedStartDate = this.datePipe.transform(valueForm.start_date, 'yyyy-MM-dd');
    let data = {
      esn_id: this.id,
      ID_jobOffer: valueForm.ID_jobOffer,
      name: valueForm.name,
      skillsOr: valueForm.skillsOr,
      skillsAnd: valueForm.skillsAnd,
      availability: valueForm.availability,
      start_date: formattedStartDate,
      end_date: formattedEndDate,
      contract_type: valueForm.contract_type,
      post_type: valueForm.post_type,
      years_of_experience: valueForm.years_of_experience,
      experience_range: valueForm.experience_range,
      profile_abroad: valueForm.profile_abroad,
      passeport_talent: valueForm.passeport_talent,
      state: valueForm.state,

      city: valueForm.city,
      country: valueForm.country,
      tjm: valueForm.tjm,
      tjm_range: valueForm.tjm_range,
      desired_salary: this.searchForm.value.desired_salary,
      desired_salary_range: this.searchForm.value.desired_salary_range,
      search: this.transformSearch(valueForm?.search),
      per_page: this.pageSize,
      page: this.currentPage
    };
    this.spinner.show();
    this.jobofferservice.searchJobsOfEsn(data).subscribe({
      next: (resSearch) => {
        this.listjoboffers = resSearch.data.data;
        this.totalItems = resSearch.data.total;
        this.spinner.hide();
      },
      error: (error) => {
        this.toastrService.error(serverError);
        this.spinner.hide();
      },
    });
  }
  freeSearchjoboffer(pageNumber: number = this.currentPage) {
    let valueForm = this.freeSearchForm.value;

    let data = {
      esn_id: this.id,
      page: this.currentPage,
      per_page: this.pageSize,
      search: this.transformSearch(valueForm?.search),
    }
    this.spinner.show();
    this.jobofferservice.searchJobsOfEsn(data).subscribe({
          next: (resSearch) => {
              const { to, from, total, current_page, data } = resSearch.data;
              this.spinner.hide();
              this.startSearching = false;
              this.listjoboffers = resSearch.data.data;
              this.totalItems = resSearch.data.total;
              this.spinner.hide();
          },
          error: (error) => {
              this.spinner.hide();
          },
      });
  }
   alreadyConverted = false;
  convertKToNumber(value: any): number {
  if (typeof value === 'string' && value.toLowerCase().endsWith('k')) {
    // Si la valeur se termine par 'k'
    const numericValue = parseFloat(value.slice(0, -1));
    if (!isNaN(numericValue)) {
      // Convertir en multipliant par 1000
      this.alreadyConverted = true; // Marquer comme déjà convertie
      return numericValue * 1000;
    }
  } else if (!isNaN(value)) {
    // Si la valeur est déjà un nombre
    if (!this.alreadyConverted) {
      this.alreadyConverted = true; // Marquer comme déjà convertie
      return parseFloat(value) * 1000;
    } else {
      return parseFloat(value); // Retourner la valeur sans multiplier à nouveau
    }
  }

  // Si aucune condition n'est remplie, retourner une valeur par défaut
  return 0; // Ou une autre valeur par défaut appropriée
}

  onPageChange(e: PageEvent): void {
    this.pageSize = e.pageSize;
    this.currentPage = e.pageIndex;
     if (this.searchForm.dirty && this.btnSearchactive) {
      this.searchjoboffer(this.currentPage);
    } 
    else if (this.freeSearchForm.dirty && this.btnSearchactive){
      this.freeSearchjoboffer(this.currentPage);
    }
    else {
      this.getListjoboffer();
    }
  }
  transformSearch(search: string): string {
    // Remplace toutes les occurrences de '||' par 'OR'
    search = search.replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    // Ajoute des espaces autour des opérations logiques pour éviter des conflits avec les mots
    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    // Remplace les termes entre guillemets doubles par les mêmes termes sans modification
    // et échappe les guillemets simples à l'intérieur des termes non compris entre guillemets
    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    // Supprime les espaces en double pour une meilleure lisibilité
    search = search.replace(/\s+/g, ' ');

    // Renvoie la chaîne de recherche transformée
    return search.trim();
  }
  getListSkills() {
    this.salarieservice.getSkills().subscribe({
      next: (res) => {
        this.skillsList = res?.data?.items?.data;
      },
      error: () => {
        this.toastrService.error(serverError);
      },
    });
  }
  getSkillsArray(candidate: any): string[] {
    if (candidate && candidate.skills) {
      return candidate.skills.split(',').map((s: string) => s.trim());
    } else {
      return [];
    }
  }
  getSkillsList(skills: string): string {
    if (!skills) {
      return '';
    }
    return skills.split(',').map(s => s.trim()).join(', ');
  }
  reset() {
    this.currentPage=0;
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.freeSearchForm.reset();
    this.freeSearchForm = this.createFreeSearchForm();
    this.getListjoboffer();
  }
}
